export default "__VITE_ASSET__CiWgLTAA__ 36w, __VITE_ASSET__D39y3NA7__ 72w, __VITE_ASSET__lhGzbwem__ 108w";